import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@proman/services/toast.service';
import { copyToClipboard } from '@proman/utils';

@Component({
    selector: 'pm-dashboard-emoji',
    template: `
    <pro-dialog-title title="emoji"></pro-dialog-title>
    <div mat-dialog-content fxLayout="column" pmPadding>
      <div fxLayout="row wrap" fxFlex>
        @for (_type of types; track _type) {
          <pro-btn
            [label]="_type"
            [theme]="_type === type ? 'accent' : 'primary'"
          (onClick)="setType(_type)"></pro-btn>
        }
      </div>
    
      <div pmPadding [ngStyle]="{ 'font-size': type ? '50px': '28px' }">
        <div>
          @if (canShow('smileys_&_people')) {
            @for (smileysAndPeopleEmoji of this.smileysAndPeopleEmojiArr; track smileysAndPeopleEmoji) {
              <pro-btn class="emojiButton"
                [label]="smileysAndPeopleEmoji"
                (onClick)="copy(smileysAndPeopleEmoji)"
                >
              </pro-btn>
            }
          }
          @if (canShow('food_&_drink')) {
            @for (foodAndDrinkEmoji of this.foodAndDrinkEmojiArr; track foodAndDrinkEmoji) {
              <pro-btn class="emojiButton"
                [label]="foodAndDrinkEmoji"
                (onClick)="copy(foodAndDrinkEmoji)"
                >
              </pro-btn>
            }
          }
          @if (canShow('animals_&_nature')) {
            @for (animalsAndNatureEmoji of this.animalsAndNatureEmojiArr; track animalsAndNatureEmoji) {
              <pro-btn class="emojiButton"
                [label]="animalsAndNatureEmoji"
                (onClick)="copy(animalsAndNatureEmoji)"
                >
              </pro-btn>
            }
          }
          @if (canShow('objects')) {
            @for (objectsEmoji of this.objectsEmojiArr; track objectsEmoji) {
              <pro-btn class="emojiButton"
                [label]="objectsEmoji"
                (onClick)="copy(objectsEmoji)"
                >
              </pro-btn>
            }
          }
          @if (canShow('office')) {
            @for (officeEmoji of this.officeEmojiArr; track officeEmoji) {
              <pro-btn class="emojiButton"
                [label]="officeEmoji"
                (onClick)="copy(officeEmoji)"
                >
              </pro-btn>
            }
          }
          @if (canShow('activity')) {
            @for (activityEmoji of this.activityEmojiArr; track activityEmoji) {
              <pro-btn class="emojiButton"
                [label]="activityEmoji"
                (onClick)="copy(activityEmoji)"
                >
              </pro-btn>
            }
          }
          @if (canShow('symbols')) {
            @for (symbolsEmoji of this.symbolsEmojiArr; track symbolsEmoji) {
              <pro-btn class="emojiButton"
                [label]="symbolsEmoji"
                (onClick)="copy(symbolsEmoji)"
                >
              </pro-btn>
            }
          }
          @if (canShow('flags')) {
            @for (flagsEmoji of this.flagsEmojiArr; track flagsEmoji) {
              <pro-btn class="emojiButton"
                [label]="flagsEmoji"
                (onClick)="copy(flagsEmoji)"
                >
              </pro-btn>
            }
          }
        </div>
    
      </div>
    
    </div>
    <pro-dialog-actions></pro-dialog-actions>
    `,
    standalone: false
})

export class DashboardEmojiDialogComponent implements OnInit, OnDestroy {
  data = inject(MAT_DIALOG_DATA);
  private Toast = inject(ToastService);

  types: string[] = [
    'smileys_&_people',
    'symbols',
    'food_&_drink',
    'activity',
    'office',
    'animals_&_nature',
    'objects',
    'flags',
  ];

  type: string;
  smileysAndPeopleEmojiArr: string[] = ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '😣', '😖', '😫'
    , '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒'
    , '🤕', '🤑', '🤠', '😈', '👿', '👹', '👺', '🤡', '💩', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '👋', '🤚', '🖐', '✋', '🖖', '👌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍'
    , '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅', '🤳', '💪', '🦾', '🦵', '🦿', '🦶', '👂', '🦻', '👃', '🧠', '🦷', '👀', '👁', '👅', '👄', '🧵', '🧶', '👓', '🕶', '🥽', '🥼', '🦺', '👔', '👕', '👖', '🧣', '🧤', '🧥', '🧦', '👗'
    , '👘', '🥻', '🩱', '🩲', '🩳', '👙', '👚', '👛', '👜', '👝', '🎒', '👞', '👟', '🥾', '🥿', '👠', '👡', '🩰', '👢', '👑', '👒', '🎩', '🎓', '🧢', '⛑', '💄', '💍', '💼', '🎊', '🎉', '💋']

  foodAndDrinkEmojiArr: string[] = ['🍏', '🍎', '🍐', '🍊', '🍋', ' 🍌', '🍉', '🍇', '🍓', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🍆', '🥑', '🥦', '🥬', '🥒', '🌶', '🌽', '🥕', '🧄', '🧅', '🥔', '🍠', '🥐', '🥯', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳', '🧈', '🥞', '🧇', '🥓', '🥩', '🍗',
    '🍖', '🦴', '🌭', '🍔', '🍟', '🍕', '🥪', '🥙', '🧆', '🌮', '🌯', '🥗', '🥘', '🥫', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🦪', '🍤', '🍙', '🍚', '🍘', '🍥', '🥠', '🥮', '🍢', '🍡', '🍧', '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫', '🍿'
    , '🍩', '🍪', '🌰', '🥜']

  animalsAndNatureEmojiArr: string[] = ['🐶', ' 🐱', ' 🐭', ' 🐹', ' 🐰', ' 🦊 ', '🐻 ', '🐼 ', '🐨 ', '🐯 ', '🦁 ', '🐮 ', '🐷 ', '🐽 ', '🐸 ', '🐵 ', '🙈 ', '🙉 ', '🙊 ', '🐒 ', '🐔 ', '🐧 ', '🐦 ', '🐤', ' 🐣', ' 🐥', ' 🦆', ' 🦅', ' 🦉', ' 🦇', ' 🐺', ' 🐗', ' 🐴', ' 🦄', ' 🐝', ' 🐛', ' 🦋', ' 🐌', ' 🐞', ' 🐜', ' 🦟', ' 🦗', ' 🕷', '🕸', ' 🦂', ' 🐢', ' 🐍', ' 🦎', ' 🦖', ' 🦕', ' 🐙', ' 🦑', ' 🦐', ' 🦞', ' 🦀', ' 🐡', ' 🐠', ' 🐟', ' 🐬', ' 🐳', ' 🐋', ' 🦈', ' 🐊', ' 🐅', ' 🐆', ' 🦓', ' 🦍', ' 🦧', ' 🐘', ' 🦛', ' 🦏', ' 🐪', ' 🐫', ' 🦒', ' 🦘', ' 🐃', ' 🐂', ' 🐄', ' 🐎', ' 🐖', ' 🐏', ' 🐑', ' 🦙', ' 🐐', ' 🦌', ' 🐕', '🐩', ' 🦮', ' 🐈', ' 🐓', ' 🦃', ' 🦚', ' 🦜', ' 🦢', ' 🦩', ' 🕊', ' 🐇', ' 🦝', ' 🦨', ' 🦡', ' 🦦', ' 🦥', ' 🐁', ' 🐀', ' 🐿', ' 🦔', ' 🐾', ' 🐉', ' 🐲', ' 🧸', ' 🌞', ' 🌝', ' 🌛', ' 🌜', ' 🌚', ' 🌕 ', '🌖 ', '🌗', ' 🌘', ' 🌑', ' 🌒', ' 🌓', ' 🌔', ' 🌙', ' 🌎', ' 🌍', ' 🌏', ' 🪐', ' 💫', '⭐', '️ 🌟', ' ✨', ' ⚡', '️ ', '☄️', ' 💥', ' 🔥', ' 🌪', ' 🌈', '️ 🌤', ' ⛅️', ' 🌥', '️ 🌦', ' 🌧', ' ⛈', ' 🌩', ' 🌨', '❄', '️ ⛄', '️ 🌬', ' 💨', ' 💧', ' 💦', '️ 🌊', ' 🌵', ' 🎄', ' 🌲', ' 🌳', ' 🌴', ' 🌱', ' 🌿', ' ☘', '️ 🍀', ' 🎍 ', '🎋 ', '🍃 ', '🍂 ', '🍁', '🍄 ', '🐚 ', '🌾 ', '💐 ', '🌷 ', '🌹 ', '🥀 ', '🌺 ', '🌸 ', '🌼 ', '🌻']

  objectsEmojiArr: string[] = ['🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺', '🎸', '🪕', '🎻', '🎲', '🎯', '🎳', '🎮', '🎰', '🧩', '🍯', '🥛', '🍼', '🍵', '🧃', '🥤', '🍶', '🍺', '🍻', '🥂', '🍷', '🥃', '🍸', '🍹', '🧉', '🍾', '🧊', '🥄', '🍴', '🍽', '🥣', '🥡', '🥢', '🧂', '🔧', '🔨', '🛠', '⛏', '🔩', '🧱', '⛓', '🧲', '🔫', '💣', '🧨', '🪓', '🔪', '🗡', '🛡', '🚬', '🏺', '🔮', '📿', '🧿', '💈', '🔭', '🔬', '🕳', '🩹', '🩺', '💊', '💉', '🩸', '🧬', '🦠', '🧫', '🧪', '🌡', '🧹', '🧺', '🧻', '🚽', '🚰', '🚿', '🛁', '🛀', '🧼', '🪒', '🧽', '🧴', '🛎', '🔑', '🗝', '🔏', '🔐', '🔒', '🔓', '🧰', '🚪', '🪑', '🛋', '🛏', '🛌', '🖼', '🛍', '🛒', '🎁', '🧳', '🌂', '🩸', '🎈', '🎏', '🎀', '🎎', '🏮', '🎐', '🧧']

  officeEmojiArr: string[] = ['⌚', '📱', '📲', '💻', '🖨', '🖱', '🖲', '🕹', '🗜', '💽', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📽', '🎞', '📞', '📟', '📠', '📺', '📻', '🎙', '🎚', '🎛', '🧭', '⏱', '⏲', '⏰', '🕰', '⌛', '⏳', '📡', '🔋', '🔌', '💡', '🔦', '🕯', '🪔', '🛢', '💸', '💵', '💴', '💶', '💷', '💰', '💳', '💎', '📩', '📨', '📧', '💌', '📥', '📤', '📦', '🏷', '📪', '📫', '📬', '📭', '📮', '📯', '📜', '📃', '📄', '📑', '🧾', '📊', '📈', '📉', '🗒', '🗓', '📆', '📅', '🗑', '📇', '🗃', '🗳', '🗄', '📋', '📁', '📂', '🗂', '🗞', '📰', '📓', '📔', '📒', '📕', '📗', '📘', '📙', '📚', '📖', '🔖', '🧷', '🔗', '📎', '🖇', '📐', '📏', '🧮', '📌', '📍', '🖊', '🖋', '🖌', '🖍', '📝', '🔍', '🔎']

  activityEmojiArr: string[] = ['⛷', '🏂', '🪂', '🏋', '🏆', '🥇', '🥈', '🥉', '🏅', '🎖', '🏵', '🎗', '🎫', '🎟', '🎪', '🤹', '🎭', '🩰', '🎨', '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🪀', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🥅', '⛳', '🪁', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽', '🛹', '🛷', '⛸', '🥌', '🎿']

  symbolsEmojiArr: string[] = ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '⚫', '⚪', '🟤', '🔺', '🔻', '🔸', '🔹', '🔶', '🔷', '🔳', '🔲', '▪️', '  ▫️', '🟥', '🟧', '🟨', '🟩', '🟦', '🟪', '⬛', '⬜', '🟫', '🏳', '🏴', '🏁', '🚩', '🏳', '🌈', '🏴', '☠']


  flagsEmojiArr: string[] = ['🇦🇫', '🇦🇽', '🇦🇱', '🇩🇿', '🇦🇸', '🇦🇩', '🇦🇴', '🇦🇮', '🇦🇶', '🇦🇬', '🇦🇷', '🇦🇲',
    '🇦🇼', '🇦🇺', '🇦🇹', '🇦🇿', '🇧🇸', '🇧🇭', '🇧🇩', '🇧🇧', '🇧🇾', '🇧🇪', '🇧🇿', '🇧🇯', '🇧🇲', '🇧🇹', '🇧🇴', '🇧🇦', '🇧🇼', '🇧🇻', '🇧🇷', '🇮🇴', '🇧🇳', '🇧🇬', '🇧🇫', '🇧🇮', '🇰🇭', '🇨🇲', '🇨🇦', '🇨🇻', '🇧🇶', '🇰🇾', '🇨🇫',
    '🇹🇩', '🇨🇱', '🇨🇳', '🇨🇽', '🇨🇨', '🇨🇴', '🇰🇲', '🇨🇬', '🇨🇩', '🇨🇰', '🇨🇷', '🇨🇮', '🇭🇷', '🇨🇺', '🇨🇼', '🇨🇾', '🇨🇿', '🇩🇰', '🇩🇯', '🇩🇲', '🇩🇴', '🇪🇨', '🇪🇬', '🇸🇻', '🏴󠁧󠁢󠁥󠁮󠁧󠁿', '🇬🇶', '🇪🇷', '🇪🇪', '🇸🇿', '🇪🇹', '🇫🇰',
    '🇫🇴', '🇫🇯', '🇫🇮', '🇫🇷', '🇬🇫', '🇵🇫', '🇹🇫', '🇬🇦', '🇬🇲', '🇬🇪', '🇩🇪', '🇬🇭', '🇬🇮', '🇬🇷', '🇬🇱', '🇬🇩', '🇬🇵', '🇬🇺', '🇬🇹', '🇬🇬', '🇬🇳', '🇬🇼', '🇬🇾', '🇭🇹', '🇭🇲', '🇭🇳', '🇭🇰', '🇭🇺', '🇮🇸', '🇮🇳', '🇮🇩',
    '🇮🇷', '🇮🇶', '🇮🇪', '🇮🇲', '🇮🇱', '🇮🇹', '🇯🇲', '🇯🇵', '🇯🇪', '🇯🇴', '🇰🇿', '🇰🇪', '🇰🇮', '🇰🇵', '🇰🇷', '🇽🇰', '🇰🇼', '🇰🇬', '🇱🇦', '🇱🇻', '🇱🇧', '🇱🇸', '🇱🇷', '🇱🇾', '🇱🇮', '🇱🇹', '🇱🇺', '🇲🇴', '🇲🇬', '🇲🇼', '🇲🇾',
    '🇲🇻', '🇲🇱', '🇲🇹', '🇲🇭', '🇲🇶', '🇲🇷', '🇲🇺', '🇾🇹', '🇲🇽', '🇫🇲', '🇲🇩', '🇲🇨', '🇲🇳', '🇲🇪', '🇲🇸', '🇲🇦', '🇲🇿', '🇲🇲', '🇳🇦', '🇳🇷', '🇳🇵', '🇳🇱', '🇳🇨', '🇳🇿', '🇳🇮', '🇳🇪', '🇳🇬', '🇳🇺', '🇳🇫', '🇲🇰', '🇲🇵',
    '🇳🇴', '🇴🇲', '🇵🇰', '🇵🇼', '🇵🇸', '🇵🇦', '🇵🇬', '🇵🇾', '🇵🇪', '🇵🇭', '🇵🇳', '🇵🇱', '🇵🇹', '🇵🇷', '🇶🇦', '🇷🇪', '🇷🇴', '🇷🇺', '🇷🇼', '🇧🇱', '🇸🇭', '🇰🇳', '🇱🇨', '🇲🇫', '🇵🇲', '🇻🇨', '🇼🇸', '🇸🇲', '🇸🇹', '🇸🇦', '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    '🇸🇳', '🇷🇸', '🇸🇨', '🇸🇱', '🇸🇬', '🇸🇽', '🇸🇰', '🇸🇮', '🇸🇧', '🇸🇴', '🇿🇦', '🇬🇸', '🇸🇸', '🇪🇸', '🇱🇰', '🇸🇩', '🇸🇷', '🇸🇯', '🇸🇪', '🇨🇭', '🇸🇾', '🇹🇼', '🇹🇯', '🇹🇿', '🇹🇭', '🇹🇱', '🇹🇬', '🇹🇰', '🇹🇴', '🇹🇹', '🇹🇳',
    '🇹🇷', '🇹🇲', '🇹🇨', '🇹🇻', '🇺🇬', '🇺🇦', '🇦🇪', '🇬🇧', '🇺🇲', '🇺🇾', '🇺🇿', '🇻🇺', '🇻🇦', '🇻🇪', '🇻🇳', '🇻🇬', '🇻🇮', '🏴󠁧󠁢󠁷󠁬󠁳󠁿', '🇼🇫', '🇪🇭', '🇾🇪', '🇿🇲', '🇿🇼']

  ngOnInit() {

  }

  ngOnDestroy() {

  }


  canShow(type: string) {
    return this.type === type || !this.type;
  }

  setType(type: string) {
    this.type = (type === this.type) ? '' : type;
  }

  copy(emoji: string) {
    copyToClipboard(emoji)
    this.Toast.pop('info', `${emoji} copied_to_clipboard`);
  }

}
